import { render, staticRenderFns } from "./DayLimitMatrix.vue?vue&type=template&id=55589c0d&scoped=true"
import script from "./DayLimitMatrix.vue?vue&type=script&lang=js"
export * from "./DayLimitMatrix.vue?vue&type=script&lang=js"
import style0 from "./DayLimitMatrix.vue?vue&type=style&index=0&id=55589c0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55589c0d",
  null
  
)

export default component.exports